export {WidgetComponent} from './widget.component';



// WEBPACK FOOTER //
// ./src/app/shared/widgets/widget/index.ts